module.exports = __webpack_public_path__ + "static/media/secietypic02@3x.9b885bc2.png";